'use client'

import React, { useState, useContext, createContext, useEffect } from 'react'
import Spinner from '../components/atoms/Spinner/Spinner.component'
// import { useRouter } from 'next/navigation'

interface LoadingContextType {
  isLoading: boolean
  setIsLoading: (loading: boolean) => void
}

interface LoadingProviderProps {
  children: React.ReactNode
}

export const LoadingContext = createContext<LoadingContextType | undefined>(undefined)

export const LoadingProvider = ({ children }: LoadingProviderProps) => {
  const [isLoading, setIsLoading] = useState<boolean>(false)

  // const router = useRouter()

  // const handleRouteChangeStart = (): void => {
  //   if (window) document.body.style.pointerEvents = 'none'
  //   setIsLoading(true)
  // }

  // const handleRouteChangeComplete = (): void => {
  //   if (window) {
  //     document.body.style.pointerEvents = 'all'
  //     document.body.style.overflow = 'auto'
  //   }
  //   setIsLoading(false)
  // }

  // useEffect(() => {
  //   router.events.on('routeChangeStart', handleRouteChangeStart)
  //   router.events.on('routeChangeComplete', handleRouteChangeComplete)
    
  //   return () => {
  //     router.events.off('routeChangeStart', handleRouteChangeStart)
  //     router.events.off('routeChangeComplete', handleRouteChangeComplete)
  //   }

  // }, [router])

  return (
    <LoadingContext.Provider value={{ isLoading, setIsLoading }}>
      { isLoading ? <Spinner /> : null }
      { children }
    </LoadingContext.Provider>
  )
}

export const useLoading = (): LoadingContextType => {
  const context = useContext(LoadingContext)
  if (context === undefined) {
    throw new Error('useLoading must be used within a LoadingProvider')
  }
  return context
}

export default LoadingProvider